// extracted by mini-css-extract-plugin
export var activityContainer = "_h7-0";
export var typingIndicatorContainer = "_h7-1";
export var typingIndicatorDot = "_h7-2";
export var wave = "_h7-3";